import { DeviceConfiguration } from '../../../data';

import { DeviceConfigurationEboxConfigurations } from './types';

export function processEboxConfiguration(
  configuration: DeviceConfigurationEboxConfigurations,
): NonNullable<DeviceConfiguration['ebox']> {
  return {
    app: {
      appStoreUrl: configuration.iOsStore,
      id: configuration.eboxAppId,
      host: configuration.eboxApplinkHost,
      playStoreUrl: configuration.androidStore,
      schema: configuration.eboxCustomScheme,
      tizenAppId: configuration.eboxTizenAppId,
      tizenStoreAppId: configuration.eboxTizenStore,
      webOsAppId: configuration.eboxLGAppId,
    },
    isMigrationEnabled: configuration.migrationEnabled,
    isServerTerminated: configuration.isServiceTerminated,
    qrCodeUrl: configuration.qrCodeUrl,
    restrictedMenuReference: configuration.restrictedMenuReferences,
    subscriptions: new Set(configuration.eboxSubscriptions ?? []),
    sunsetAssetId: configuration.sunsetScreenAsset,
  };
}
